$(document).ready(function () {
  var $badgeSlider = $('.badge-slider-container');

  if($badgeSlider.length) {
    var $slider = $badgeSlider.slick({
      dots: true,
      arrows: false,
      mobileFirst: true,
      responsive: [{
        breakpoint: 991,
        settings: "unslick"
      }]
    });

    $(window).on('resize', function() {
      $slider.slick('resize');
    });
  }

});